
function CommentsController(MessageService, CommentsService, TranslationService, $scope) {
    var ctrl = this;

    ctrl.prefs = {
        issueID: null,
        loading: false,
        loaded: false,
        error: false,
        textAreaFocus: null,
        quantity: 5
    };

    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {
        ctrl.loaded = false;

        if (!ctrl.commentPlaceholder) {
            ctrl.commentPlaceholder = ctrl.translation.TypeAComment; //'Digite um comentário...';
        }

        if (!ctrl.comments) {
            ctrl.comments = [];
        }
    };

    ctrl.$onChanges = function (changes) {
        if (changes.issueId) {
            if (changes.issueId.currentValue) {
                ctrl.loadComments(changes.issueId.currentValue);
            }
            else {
                ctrl.comments = [];
            }
        }
    };

    ctrl.getAvatar = function (userID) {
        return MessageService.getAvatar(userID);
    };

    ctrl.addComment = function () {
        if (ctrl.commentText && ctrl.commentText !== '') {
            ctrl.prefs.textAreaFocus = false;
            var comment = {
                EntityID: ctrl.issueId,
                EntityName: ctrl.entity,
                Comments: ctrl.commentText,
                UserID: ctrl.userID,
                UserMail: ctrl.userID,
                CommentDate: new Date(),
            };
            ctrl.comments.push(comment);
            ctrl.postComment(comment);
            ctrl.commentText = null;
        }
    };

    ctrl.userID = '';

    ctrl.getLoggedUser = function () {
        CommentsService.getUser().then(function (response) {
            ctrl.userID = response.data;
        });
    };

    ctrl.getLoggedUser();

    ctrl.loadComments = function (issueID) {
        ctrl.prefs.loading = true;
        var screen = ctrl.entity;
        ctrl.prefs.textAreaFocus = false;
        ctrl.prefs.quantity = 5;
        ctrl.comments = [];
        CommentsService.list(issueID, screen).then(function (data) {
            ctrl.comments = data.data;
            ctrl.prefs.loading = false;
            ctrl.prefs.loaded = true;
        });
    };

    ctrl.postComment = function (newComment) {

        if (!newComment.EntityID) {
            newComment.errorDescription = 'EntityID indefinido para o comentário';
        }
        newComment.saving = true;
        CommentsService.addNew(newComment).then(function (data) {
            newComment.saving = false;
            newComment.success = true;
            newComment.error = false;
            if (data) {
                newComment.CommentID = data.CommentID;
            }
            CommentsService.resetCache();
        });
    };

    ctrl.keyPressed = function (keyEvent) {
        if (keyEvent.keyCode === 13 && !keyEvent.shiftKey) {
            if (ctrl.issueId) {
                ctrl.addComment();
                keyEvent.preventDefault();
            }
        }

    };

    ctrl.showMoreComments = function () {
        var quantity = ctrl.prefs.quantity,
            commentCount = ctrl.comments.length;

        if (quantity >= commentCount) {
            quantity = 5;
        } else if (quantity < commentCount) {
            quantity = quantity + 5;
        }

        ctrl.prefs.quantity = quantity;
    };

    window.onclick = function (event) {
        if (!event.target.closest('#commentsbox')) {
            ctrl.prefs.textAreaFocus = false;
            //JRM: Gera erro, $apply already in progress
            //$scope.$apply() 
        }
    };

}

CommentsController.$inject = ['MessageService', 'CommentsService', 'TranslationService', '$scope'];

seedWebApp.component('sdComments', {
    controller: CommentsController,
    bindings: {
        entity: '<',
        issueId: '<',
        comments: '=?',
        commentText: '=?',
        commentPlaceholder: '<',
        disableCommentButton: '<'
    },
    templateUrl: '/SPA/Components/sd-comments.html',
});